const CryptoJS = require("crypto-js");
export const domain = {
    xh: "https://www.xinghuo365.com", //星火
    tm: "https://www.itoumi.com" //投米
};
let origin = location.origin;
let xhjf = 'https://sadata.yixin.com/sa?project=xhjftest',xhjf2 = 'https://sadata.xinghuo365.com/sa?project=xhjftest';
if(origin === 'https://www.itoumi.com'){
    xhjf = 'https://sadata.yixin.com/sa?project=xhjf';
    xhjf2 = 'https://sadata.xinghuo365.com/sa?project=xhjf';
}
// 神策的地址
export const sensorsConfig = {
    xhjf: xhjf,
    xhlcs: "https://sadata.yixin.com/sa?project=xhlcs",
    xhjf2: xhjf2,
    xhlcs2: "https://sadata.xinghuo365.com/sa?project=xhlcs",
};
// 对称解密
export const decrypt = function(str) {
    if(typeof str == 'object'){
        return str;
    }
    let key = CryptoJS.enc.Utf8.parse('meiyoushenheyiyi');
    let option = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    let result = CryptoJS.AES.decrypt(str.toString(), key, option).toString(CryptoJS.enc.Utf8);
    // console.log('descrypt',str,result);
    return typeof result == 'object'?result:JSON.parse(result);
}
